<div #nt class="newsticker">
  <small #ntCounter class="nt-counter">{{current}}</small>
  <div #ntTitle class="nt-title">
    <h2 [innerHTML]="title | safeHtml"></h2>
    <span #nDart></span>
  </div>
  <div class="nt-content">
    <label [innerHTML]="item | safeHtml"></label>
  </div>
  <div class="nt-navi">
    <span (click)="navigate('PREV')">
      <i #ntNavi class="arrow-left"></i>
    </span>
    <span (click)="navigate('NEXT')">
      <i #ntNavi class="arrow-right"></i>
    </span>
  </div>
</div>
